import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { usePaintConfiguratorContext } from "@/components/PaintConfigurator/context/paintConfigurator.context";
import { useMapped } from "@/context/mapped.context";

import { useFamiliesContext } from "../context/families.context";

const Family = () => {
    const { families } = useFamiliesContext();
    const { setSelectedFamily, nextStep } = usePaintConfiguratorContext();
    const { index } = useMapped();

    const family = families.at(index);
    if (!family) return null;

    return (
        <Button
            style={{ backgroundColor: family.hex }}
            color="transparent"
            className={cn(
                "tw:group tw:hover:ring-1 tw:overflow-hidden tw:hover:ring-gray-300 tw:hover:ring-offset-2 tw:hover:scale-[1.01] tw:transition-all"
            )}
            onClick={() => {
                setSelectedFamily(family.name);
                nextStep();
            }}
        >
            <div
                className={cn(
                    "tw:aspect-4/3 tw:w-full tw:transition-transform tw:duration-500 tw:group-hover:scale-105"
                )}
            />
            <div
                className={cn(
                    "tw:absolute tw:inset-0 tw:bg-linear-to-t tw:from-black/30 tw:to-transparent tw:opacity-0 tw:group-hover:opacity-100 tw:transition-opacity tw:duration-300"
                )}
            />
            <div
                className={cn(
                    "tw:absolute tw:bottom-0 tw:left-0 tw:right-0 tw:p-3 md:tw:p-4"
                )}
            >
                <div className={cn("tw:flex tw:items-center tw:gap-2")}>
                    <div className={cn("tw:flex tw:-space-x-1")}>
                        {family.topColors.map((color, i) => (
                            <div
                                key={i}
                                className={cn(
                                    "tw:w-3 tw:h-3 tw:rounded-full tw:border tw:border-white/60"
                                )}
                                style={{ backgroundColor: `#${color}` }}
                            />
                        ))}
                    </div>
                </div>
                <p
                    className={cn(
                        "tw:text-sm tw:font-medium tw:text-dark tw:group-hover:text-white tw:mt-2 tw:transition-colors tw:duration-300 tw:text-left"
                    )}
                >
                    {family.name}
                </p>
            </div>
        </Button>
    );
};

export { Family };
